export enum DISTRIBUTION_CENTER_PERMISSIONS {
  DISTRIBUTION_CENTER_VIEW = 'INVENTORY_DISTRIBUTIONCENTERVIEW',
  DISTRIBUTION_CENTER_WRITE = 'INVENTORY_DISTRIBUTIONCENTERWRITE',
}
